import React from 'react';

const CaQuizzesListItem = (props) => {
    const { content, title, image, cta, ctaCallback } = props;
    return(
        <div className="QuizzesList__content-wrapper" >
            <div className="QuizzesList__text-wrapper">
                <h2>{title}</h2>
                <div className={"QuizzesList__text-image"}>
                    <div>
                        <p><span dangerouslySetInnerHTML={{__html: content}}></span></p>
                        <div className={"QuizzesList__buttonWrapper"}>
                            <button onClick={ () => ctaCallback() } className={"QuizzesList__submitButton"}>{cta}</button>
                        </div>
                    </div>

                    <div className="QuizzesList__image-wrapper QuizzesList__image-wrapper--mobile">
                        { image ? <img src={image} /> : null }
                    </div>
                </div>
            </div>
            <div className="QuizzesList__image-wrapper QuizzesList__image-wrapper--tabletup">
                { image ? <img src={image} /> : null }
            </div>
        </div>
    );
};

export default CaQuizzesListItem;
